import { CoockieConsentComponent } from './coockie-consent/coockie-consent.component';

import { Routes } from '@angular/router';

export const appRoutes: Routes = [
  {
    path: 'coockie-policy',
    component: CoockieConsentComponent,
  }
];